import React from "react";
import { Phone, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/site";
import { logAttribution } from "@/lib/tracking";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-navy-900/95 backdrop-blur-xl border-t border-white/10 pb-safe"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href={BRAND.phoneHref}
          onClick={() => logAttribution("sticky_mobile_call")}
          data-testid="sticky-call"
          className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 text-white rounded-full py-3 text-sm font-medium active:scale-95 transition-transform"
        >
          <Phone className="h-4 w-4 text-gold-300" strokeWidth={1.75} />
          Call now
        </a>
        <Link
          to="/contact"
          onClick={() => logAttribution("sticky_mobile_book")}
          data-testid="sticky-book"
          className="inline-flex items-center justify-center gap-2 bg-gold-400 text-navy-900 rounded-full py-3 text-sm font-semibold active:scale-95 transition-transform"
        >
          <Calendar className="h-4 w-4" strokeWidth={1.75} />
          Free consult
        </Link>
      </div>
    </div>
  );
}
